import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useRouter } from '@/router/useRouter'
import { useJwtStore } from '@/stores/jwt'
import { useSearchStore } from '@/stores/search'
import { useBannerStore } from '@/stores/banner'

const Names = {
  fr: 'accueil',
  en: 'home'
}

const Config: TrPageConfigInterface = {
  name: Names.en,
  path: '/',
  alias: `/${Names.fr}`,
  meta: {
    title: {
      fr: 'Accueil',
      en: 'Home'
    }
  },
  component: () => import('@page/home/Home.vue'),
  beforeEnter: async (to, from, next) => {
    await useRouter().preloadSettingPage(to)
    try {
      const jwtStore = useJwtStore()
      await jwtStore.fetchAccessToken()
      await jwtStore.getLoggedUser()
      await jwtStore.getPatients()
      useBannerStore().showAnnounceBanner = false
    } catch (error) {
      console.log(error)
      // Silent refresh token error
    }

    useSearchStore().resetSearchCalled()

    next()
  }
}

export { Config }
